module.exports = __webpack_public_path__ + "static/media/tiendaRoja.093c9b86.png";